// BcpEmployeeList.js

import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom'; 
import { apiGet, apiPostJSON } from '../services/api'; 
import './BcpEmployeeList.css';

const BcpEmployeeList = () => {
  const [employees, setEmployees] = useState([]);
  const [filters, setFilters] = useState({ name: '', departmentName: '', city: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    /*
    try {
      const params = new URLSearchParams(filters).toString();
      
      const response = await fetch(`/api/admin/bcp/employee-list/?${params}`, {
        credentials: 'include',
      });

        if (response.status === 401) {
          
            throw new Error('認証エラー (401): セッションが切れました。管理者としてログインし直してください。');
        }

        if (!response.ok) {
           
            throw new Error(`HTTPエラーが発生しました: ${response.status}`);
        }

        const data = await response.json();
        setEmployees(data);

    
    } catch (err) {
    
        setError(`データベースを取得エラー: ${err.message}`);
    */
    try {
      const params = new URLSearchParams(filters).toString();
      const data = await apiGet(`/api/admin/bcp/employee-list/?${params}`);
      setEmployees(data);

    } catch (error) {
        console.error("BCPのデータベースを取得エラー:", error);
        setError("BCP社員リストの取得に失敗しました。");
    } finally {
        setLoading(false);
    }
    
  }, [filters]);

  const handleGeocodeTrigger = async () => {
    if (!window.confirm("全ての住所の座標を更新しますか？時間（数分）がかかる可能性があります。")) {
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const response = await apiPostJSON('/api/admin/bcp/geocode-unprocessed/', {});

      alert(`Geocodingが完了しました。 ${response.processed_count}件の住所を処理しました。リストを再読込みします。`);
      await fetchData();
    } catch (error) {
      setError(`座標更新エラーが発生しました: ${error.message}`);
      console.error("座標更新エラー:", error);

    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchData();
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    fetchData(); 
  };

  if (loading) return <div className="bcp-admin-container"><p>データをローディング...</p></div>;
  if (error) return <div className="bcp-admin-container"><p className="error">{error}</p></div>;

  return (
    <div className="bcp-admin-container">
      {/* h2タイトルは BCPAdmin.js のタブで表示済みのため削除 */}
      <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        <button className="btn-primary" onClick={handleGeocodeTrigger} disabled={loading}>
          未設定住所の座標を一括更新
        </button>
      </div>

      <form onSubmit={handleFilterSubmit} className="filter-form">
        <input 
          type="text" 
          name="name" 
          placeholder="社員名または社員コード"
          value={filters.name} 
          onChange={handleFilterChange} 
        />
        <input 
          type="text" 
          name="departmentName" 
          placeholder="部署名"
          value={filters.departmentName} 
          onChange={handleFilterChange} 
        />
        <input 
          type="text" 
          name="city" 
          placeholder="市区町村"
          value={filters.city} 
          onChange={handleFilterChange} 
        />  
        
        <button type="submit" className="btn-secondary">検索</button>
      </form>

      {/* 結果表示 */}
      <div className="table-wrapper">
        <table className="employee-bcp-table">
          <thead>
            <tr>
              <th>社員コード</th>
              <th>社員氏名</th>
              <th>部署名</th>
              <th>住所</th>
              <th>避難所 (1km)</th>
              <th>距離 (km)</th>
            </tr>
          </thead>
          <tbody>
            {employees.length > 0 ? (
              employees.map(item => (
                <tr key={item.employee?.memberId || item.employee?.employeeId || item.id}>
                  <td>{item.employee.memberId}</td>
                  <td title={item.employee?.name || item.employee?.employeeName || ''}>
                    {item.employee?.name || item.employee?.employeeName || '—'}
                  </td>
                  
                  <td>{item.employee.departmentName}</td> 
                  <td>{item.employee.address}</td>
                  <td>
                    {item.nearest_shelter_info ? 
                      <strong>{item.nearest_shelter_info.name}</strong> : 
                      '1km内で避難所を見つかりませんでした。 (<1km)'}
                  </td>
                  <td>
                    {item.distance_to_shelter_km !== null &&
                      item.distance_to_shelter_km !== undefined ?
                        item.distance_to_shelter_km.toFixed(3) : '-'}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center' }}>社員が見つかりませんでした.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BcpEmployeeList;